// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.htmltopdf #client-content-header {
  display: none !important;
}
.htmltopdf #client-content-footer {
  display: none !important;
}
.htmltopdf button.jump-button {
  display: none;
}
.htmltopdf #toolbar .inner-container div.pull-right {
  display: none;
}
.htmltopdf {
  margin-left: 10px;
}
.htmltopdf #sticky-header #navbar {
  display: none;
}
.htmltopdf div.description-container {
  display: none !important;
}
.htmltopdf .com-mod-table-label a {
  color: #337ab7;
}
.htmltopdf #afis-app .strong {
  font-weight: bold !important;
}
.htmltopdf #afis-app #com-mod-returns-section .experience-cell-wrap .industry-experience-cell .strong {
  font-weight: bold !important;
}
.htmltopdf #afis-app .gray-bar-top {
  border-top: 2px solid #ccc !important;
}
.htmltopdf #afis-app .gray-bar-bottom {
  border-bottom: 1px solid #ccc !important;
}
.htmltopdf #afis-app section {
  border-top: 2px solid #666 !important;
}
.htmltopdf #afis-app .com-mod-section-container h3 {
  font-weight: 500 !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/printToPDF.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".htmltopdf #client-content-header {\n  display: none !important;\n}\n.htmltopdf #client-content-footer {\n  display: none !important;\n}\n.htmltopdf button.jump-button {\n  display: none;\n}\n.htmltopdf #toolbar .inner-container div.pull-right {\n  display: none;\n}\n.htmltopdf {\n  margin-left: 10px;\n}\n.htmltopdf #sticky-header #navbar {\n  display: none;\n}\n.htmltopdf div.description-container {\n  display: none !important;\n}\n.htmltopdf .com-mod-table-label a {\n  color: #337ab7;\n}\n.htmltopdf #afis-app .strong {\n  font-weight: bold !important;\n}\n.htmltopdf #afis-app #com-mod-returns-section .experience-cell-wrap .industry-experience-cell .strong {\n  font-weight: bold !important;\n}\n.htmltopdf #afis-app .gray-bar-top {\n  border-top: 2px solid #ccc !important;\n}\n.htmltopdf #afis-app .gray-bar-bottom {\n  border-bottom: 1px solid #ccc !important;\n}\n.htmltopdf #afis-app section {\n  border-top: 2px solid #666 !important;\n}\n.htmltopdf #afis-app .com-mod-section-container h3 {\n  font-weight: 500 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
